import { BarChartData } from './charts/barChartData'
import { NoDetects } from './filters'
import { colors } from '../plugins/vuetify'

export class RQ {
    barChartData: BarChartData | null


    constructor(rqsFiltered: [number, number, number, number, number, number, number, number, number],
        filter: NoDetects) {

        if (rqsFiltered) {
            this.barChartData = new BarChartData()

            if (filter.isShow()) {
                this.barChartData.add("No Detect", "RQ = 0", colors.noDetect, "No Detect", rqsFiltered[0], "%")
            }
            this.barChartData.add("Insignificant Risk", "0 < RQ <= 0.001", colors.insignificant, "", rqsFiltered[1], "%")
            this.barChartData.add("Insignificant Risk", "0.001 < RQ <= 0.01", colors.insignificant, "", rqsFiltered[2], "%")
            this.barChartData.add("Insignificant Risk", "0.01 < RQ <= 0.1", colors.insignificant, "", rqsFiltered[3], "%")
            this.barChartData.add("Low Risk", "0.1 < RQ <= 1", colors.low, "Low", rqsFiltered[4], "%")
            this.barChartData.add("Moderate Risk", "1 < RQ <= 10", colors.med, "", rqsFiltered[5], "%")
            this.barChartData.add("High Risk", "RQ > 10", colors.high, "High", rqsFiltered[6], "%")
        } else {
            this.barChartData = null
        }

    }
}